import { API_URL_ROOT } from '@/axios/config'
import { tokenManager } from '@/services/TokenManager/TokenManager'

/**
 * ENG-2037: Segment events go through the backend relay (`POST /v1/analytics/track`) rather
 * than straight to the services API, which now needs a server-side key. The relay takes the
 * user from the session, so callers pass only the event and its properties.
 */
class SegmentService {
  private static instance: SegmentService

  public static getInstance(): SegmentService {
    if (!SegmentService.instance) {
      SegmentService.instance = new SegmentService()
    }
    return SegmentService.instance
  }

  public track(
    event: string,
    properties: Record<string, string | number>
  ): void {
    this.send(event, properties).catch(() => undefined)
  }

  private async send(
    event: string,
    properties: Record<string, string | number>
  ): Promise<void> {
    const token = await tokenManager.getValidAccessToken()
    if (!token) return
    // fetch + keepalive, not axios: the request must survive a navigation (ad clicks).
    await fetch(`${API_URL_ROOT}/v1/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ event, properties }),
      keepalive: true,
    })
  }
}

export const segmentService = SegmentService.getInstance()
